import { z } from 'src/lib'
import { schemaEntityWithId } from 'src/types'

export const FirmaFields = {
    IdOperacion: 'idOperacion',
    CodFirmaTipo: 'codFirmaTipo',
    IdGrupo: 'idGrupo',
    MailUsuarioFirma: 'mailUsuarioFirma',
    FechaFirma: 'fechaFirma',
    Observaciones: 'observaciones',
    ApellidoYNombre: 'apellidoYNombre',
    PermiteFirmar: 'permiteFirmar',
    Etiqueta: 'etiqueta',
    CodFirmaResultadoTrue: 'codFirmaResultadoTrue',
    CodFirmaResultadoFalse: 'codFirmaResultadoFalse',
    LabelBotonTrue: 'labelBotonTrue',
    LabelBotonFalse: 'labelBotonFalse',
    Cargo: 'cargo',
    CodFirmaResultado: 'codFirmaResultado',
    DescFirmaResultadoCompletado: 'descResultadoFirmaCompletada'
} as const

export const FirmaLabelFields = {
    IdOperacionFirma: 'intIdOperacionFirma',
    CodFirmaResultadoTipo: 'codFirmaResultadoTipo',
    ResultadoLabel: 'firmaResultadoDescripcion'
} as const

export const schemaFirma = z
    .object({
        [FirmaFields.ApellidoYNombre]: z.string().nullable(),
        [FirmaFields.CodFirmaTipo]: z.number(),
        [FirmaFields.FechaFirma]: z.coerce.date().nullable(),
        [FirmaFields.IdGrupo]: z.number().nullable(),
        [FirmaFields.IdOperacion]: z.number(),
        [FirmaFields.MailUsuarioFirma]: z.string().email().nullable(),
        [FirmaFields.Observaciones]: z.string().optional().nullable(),
        [FirmaFields.PermiteFirmar]: z.boolean(),
        [FirmaFields.Etiqueta]: z.string().nullable(),
        [FirmaFields.Cargo]: z.string().nullable(),
        [FirmaFields.CodFirmaResultado]: z.number().nullable(),
        [FirmaFields.DescFirmaResultadoCompletado]: z.string().nullable().optional(),
    })
    .merge(schemaEntityWithId)

export const schemaFirmaLabel = z
    .object({
        [FirmaLabelFields.CodFirmaResultadoTipo]: z.number(),
        [FirmaLabelFields.IdOperacionFirma]: z.number(),
        [FirmaLabelFields.ResultadoLabel]: z.string()
    })
    .merge(schemaEntityWithId)

export const schemaFirmasConLabels = z.object({
    firmas: z.array(schemaFirma),
    labels: z.array(schemaFirmaLabel)
})

export type Firma = z.infer<typeof schemaFirma>
export type FirmaLabel = z.infer<typeof schemaFirmaLabel>
export type FirmasConLabels = z.infer<typeof schemaFirmasConLabels>

export const FirmaPutFields = {
    CodFirmaResultado: 'codFirmaResultado',
    CodUsuarioFirma: 'codUsuarioFirma',
    FirmaUsuario: 'firmaUsuario',
    MailUsuario: 'mailUsuario',
    Observaciones: 'observaciones'
} as const
